<div class="loading-overlay-spinner">
    <div class="loader"></div>
</div>
